export default {
    ToastPackageSaveFailed: 'Failed to save a package. Please try again.',
    ToastProposalFromCartSaved:
        'Proposal was successfully created.<a href="/manage.html?type=proposal"> See on Proposals page</a>.',
    ToastProposalSaveFailed: 'Failed to save a proposal. Please try again.',
    ToastScreenDetailsUnavailable: 'Failed to get screen details. Please try again',
};
